<template>
  <div>
    <t-upload
      v-if="!type || type !== 'video'"
      action="#"
      :value="format(files)"
      :showImageFileName="false"
      :allowUploadDuplicateFile="true"
      @fail="handleFail"
      :beforeUpload="beforeUpload"
      theme="image"
      accept="image/*"
      :multiple="multiple"
      :max="max"
      :tips="tips"
      @remove="onRemove"
    ></t-upload>
    <div class="video" v-if="type && type == 'video'">
      <div class="videos">
        <div
          v-for="(item, index) in files"
          :key="index"
          v-if="files.length > 0"
          class="videoItem"
          @mouseover="hoveredIndex = index"
          @mouseleave="hoveredIndex = null"
        >
          <video :src="$envConst.IMAGE_ORIGIN + item.url" width="110"></video>
          <div v-if="hoveredIndex === index" class="actions">
            <img
              src="@/assets/img/preview-video.png"
              alt=""
              @click="perveiewVideo(index)"
            />
            <t-divider layout="vertical" />
            <img
              src="@/assets/img/delete-video.png"
              alt=""
              @click="deleteVideo(index)"
            />
          </div>
        </div>
        <t-upload
          v-if="files && files.length < max"
          action="#"
          :value="format(files)"
          :showImageFileName="false"
          :allowUploadDuplicateFile="true"
          @fail="handleFail"
          :beforeUpload="beforeUpload1"
          theme="file"
          accept="video/*"
          :multiple="multiple"
          :max="max"
          :tips="tips"
        >
          <t-button variant="dashed" :loading="videoLoading">
            <AddIcon slot="icon" />
            点击上传视频</t-button
          >
        </t-upload>
      </div>
    </div>
    <t-dialog :visible.sync="dialogVisible" width="60%" :footer="false">
      <video v-if="previewUrl" controls :src="previewUrl"></video>
    </t-dialog>
  </div>
</template>
<script>
import { AddIcon } from 'tdesign-icons-vue'
export default {
  name: 'MXUpload',
  props: ['value', 'tips', 'max', 'multiple', 'folder', 'type', 'dataType'],
  components: {
    AddIcon,
  },
  data() {
    return {
      files: [],
      hoveredIndex: -1,
      dialogVisible: false, // 预览对话框是否可见
      previewUrl: null, // 当前预览的视频 URL
      videoLoading: false, //上传视频加载
    }
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) {
          this.files = newValue
        } else {
          this.files = []
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onRemove(e) {
      this.files.splice(e.index, 1)
    },
    format(arr) {
      return arr.map((x) => {
        return {
          ...x,
          url: this.$envConst.IMAGE_ORIGIN + (x.url?x.url:x),
        }
      })
    },
    beforeUpload(file) {
      if (!this.folder) {
        this.$Notice.warning({
          title: '上传错误',
          desc: `必须指定上传文件夹`,
        })
        return false
      }
      let formData = new FormData()
      formData.append('folder', this.folder)
      formData.append('file', file.raw)
      this.$axios.post('/funs/upload/image', formData).then((data) => {
        if(this.dataType == "array"){
          this.files.push(data)
        }else{
          this.files.push({ url: data, id: data })
        }
        this.$emit('on-change', this.files)
      })
      return false
    },
    beforeUpload1(file) {
      console.log('file', file)
      if (!this.folder) {
        this.$Notice.warning({
          title: '上传错误',
          desc: `必须指定上传文件夹`,
        })
        return false
      }
      if (file.type != 'video/mp4') {
        this.$Notice.warning({
          title: '上传错误',
          desc: `必须指定上传视频文件`,
        })
        return false
      }
      this.videoLoading = true
      let formData = new FormData()
      formData.append('folder', this.folder)
      formData.append('file', file.raw)
      this.$axios.post('/funs/upload/video', formData).then((data) => {
        this.files.push({ url: data, id: data })
        this.$emit('on-change', this.files)
        this.videoLoading = false
      })
      return false
    },
    handleFail({ file }) {
      this.$message.error(`文件 ${file.name} 上传失败`)
    },
    perveiewVideo(index) {
      this.previewUrl =
        this.files[index].url || URL.createObjectURL(this.files[index].raw)
      this.dialogVisible = true
    },
    deleteVideo(index) {
      // 删除视频
      this.files.splice(index, 1)
    },
  },
}
</script>

<style scoped>
.tdesign-demo-upload-item {
  display: inline-block;
  margin-right: 80px;
}
.tdesign-demo-upload-item + .tdesign-demo-upload-item {
  margin-top: 80px;
}
:deep(.t-upload__card-image) {
  width: 100%;
  height: 100%;
  max-width: auto;
  max-height: auto;
}
.video {
  display: flex;
  align-items: center;
  .t-upload {
    margin-bottom: 8px;
  }
  :deep(.t-upload__single-display-text) {
    display: none !important;
  }
  .videos {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    /* video::-webkit-media-controls-enclosure {
      display: none;
    } */
    & > .videoItem {
      width: 110px;
      height: 110px;
      border-radius: 3px;
      background: #f3f3f3;
      border: 1px dashed #ddd;
      padding: 8px;
      margin-right: 8px;
      margin-bottom: 8px;
      position: relative;
      cursor: pointer;
      & > video {
        width: 100%;
        height: 100%;
      }
      .actions {
        position: absolute;
        width: 110px;
        z-index: 2;
        height: 110px; /* 确保按钮在视频上方 */
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.6);
        display: none;
        & > img {
          width: 16px;
          height: 16px;
        }
      }
    }
    & > .videoItem:hover .actions {
      display: flex; /* 鼠标悬停时显示删除按钮 */
      align-items: center;
      justify-content: center;
    }
  }
  .t-button {
    width: 110px;
    height: 110px;
    background: rgb(243, 243, 243);
    color: rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    font-size: 12px;
    .t-icon-add {
      width: 24px;
      height: 24px;
      color: rgba(0, 0, 0, 0.4);
      margin-bottom: 8px;
    }
  }
}
:deep(.t-dialog) {
  height: 70vh !important;
  video {
    width: 100%;
    max-height: 60vh;
  }
}
</style>
